/*
 * Copyright (c) Logan Group Services - Gaston Longhitano <gaston.longhitano@logangroupservices.com>
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

//import sleep from '@react-corekit/sleep';

async function getGame({id}) {
    try {
        //await sleep(2000);
        const response = await fetch(`${document.config?.apiUrl}/games/${document.config?.gameID}`);
        const data = await response.json();
        console.log(data);
        if ((Object.keys(data).length === 0)) {
            throw new Error('Game not found');
        }
        return {
            game: data
        }
    } catch (e) {
        return { error: e};
    }
}

async function getScene({id}) {
    try {
        //await sleep(2000);
        const response = await fetch(`${document.config?.apiUrl}/scenes/${id}`);
        const data = await response.json();
        console.log(data);
        if ((Object.keys(data).length === 0)) {
            throw new Error('Scene not found');
        }
        return {
            scene: data
        }
    } catch (e) {
        return { error: e};
    }
}

async function getCurrentUser({id}) {
    try {
        const response = await fetch(`${document.config?.apiUrl}/users/${id}`);
        const data = await response.json();
        if ((Object.keys(data).length === 0)) {
            throw new Error('User not found');
        }
        return {
            user: data
        }
    } catch (e) {
        return { error: e};
    }
}

async function setLatestWatchedSceneID({gameID, sceneID, userID}) {
    try {
        const response = await fetch(`${document.config?.apiUrl}/users/${userID}/history`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                gameID: gameID,
                latestWatchedSceneID: sceneID
            })
        });
        const data = await response.json();

        if ((Object.keys(data).length === 0)) {
            throw new Error('Error setting history');
        }
        return {
             data
        }
    }catch (e) {
        return { error: e};
    }
}

const sign = (url) => `${document.config?.apiUrl}/cdn/sign?redirect=1&url=${url}`;

export {
    sign,
    getGame,
    getScene,
    getCurrentUser,
    setLatestWatchedSceneID
}
